export default "__VITE_ASSET__BJKAHIFe__"